var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "booking-status" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "p",
        { staticClass: "col-xs-12" },
        [
          _vm.bookingTypeIsBooking
            ? _c("span", [
                _vm._v(
                  "Booking #" + _vm._s(_vm._f("padded")(_vm.booking.id, "0", 5))
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("booking-status-label", { attrs: { booking: _vm.booking } }),
          _vm._v(" "),
          _vm.booking.urgent
            ? _c("span", { staticClass: "status status-bad" }, [
                _vm._v("Urgent"),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _vm.$userIsAdmin && (_vm.bookingIsCancelled || _vm.bookingIsWithdrawn)
        ? _c("div", { staticClass: "col-xs-12" }, [
            _c("p", { staticClass: "pull-right" }, [
              _vm._v("Withdraw Reason: " + _vm._s(_vm.bookingWithdrawReason)),
            ]),
            _vm._v(" "),
            !_vm.booking.talent.length
              ? _c("p", [
                  _vm._v(
                    "Note: No " +
                      _vm._s(
                        _vm.$declineModuleEnabled
                          ? _vm.$t("Applied")
                          : "Accepted"
                      ) +
                      " Stars"
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$userIsAdmin && _vm.bookingIsDeclined && _vm.bookingWithdrawReason
        ? _c("div", { staticClass: "right col-xs-12" }, [
            _c("p", [
              _vm._v("Decline Reason: " + _vm._s(_vm.bookingWithdrawReason)),
            ]),
            _vm._v(" "),
            !_vm.booking.talent.length
              ? _c("p", [
                  _vm._v(
                    "Note: No " +
                      _vm._s(
                        _vm.$declineModuleEnabled
                          ? _vm.$t("Applied")
                          : "Accepted"
                      ) +
                      " Stars"
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }